import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

export default function Layout() {
  return (
    <>
      {/* Subtle vignette for depth (no photo). */}
      <div className="site-bg-vignette" />

      <Navbar />
      <main className="container" style={{ paddingTop: 'var(--sp-6)', paddingBottom: 'var(--sp-6)', minHeight: '60vh' }}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
